import { Component, OnInit, Input, OnDestroy, HostListener, ElementRef, Renderer2, ViewChild, Output, EventEmitter, SimpleChanges, OnChanges } from '@angular/core';
import { Http } from '@angular/http';
import { DropDownService } from './dropdown.service';
@Component({
  selector: 'ant-dropdown-search',
  template:`<div class="container ant-dropdown-link" [ngClass]="{mousedown:_isMouseDown}">{{title}}<i class='anticon anticon-down' (click)="_isToggle = !_isToggle;_isMouseDown = !_isMouseDown;" ></i></div>
<ul class="menu ant-dropdown-menu  ant-dropdown-menu-container" *ngIf="_isToggle" >
    <li class="ant-dropdown-menu-item" *ngFor="let message of messages;let i = index;">
        <input class="ant-dropdown-input" [(ngModel)]="message.title" type="text" [readonly]="message?._isFlag" [ngClass]="{antfocusline:message?._isFocusLine,'color-change':message?.isDefault}">
        <p class="ant-dropdown-operate">
            <!-- <span *ngIf="_flagTouch_default" class="anticon anticon-check " (click)="defaultItem($event,i)"></span> -->
            <span class="anticon anticon-edit " (click)="editItem($event,i)"></span>
            <span class="anticon anticon-save "  (click)="reserveItem($event,i)"></span>
            <span class="anticon anticon-delete " (click)="delItem($event,i)"></span>
        </p>  
    </li>
    <li class="ant-dropdown-menu-item">
        <input type="text" placeholder="search message" style="border:none;width:90px;margin-right:5px" [(ngModel)]="addText">
        <i class="anticon anticon-file-add" (click)="addItem()"></i>
    </li>
</ul>

<!-- _flagTouch_del = false;
_flagTouch_add = false;
_flagTouch_reserve = false;
_flagTouch_default = false; -->`,
  styles: [`.ant-dropdown {
  position: absolute;
  left: -9999px;
  top: -9999px;
  z-index: 1050;
  display: block;
  font-size: 12px;
  font-weight: normal;
  line-height: 1.5;
}
.ant-dropdown-wrap {
  position: relative;
}
.ant-dropdown-wrap .ant-btn > .anticon-down {
  display: inline-block;
  font-size: 12px;
  font-size: 10px \9;
  transform: scale(0.83333333) rotate(0deg);
  /* IE6-IE8 */
  -ms-filter: "progid:DXImageTransform.Microsoft.Matrix(sizingMethod='auto expand', M11=1, M12=0, M21=0, M22=1)";
  zoom: 1;
}
:root .ant-dropdown-wrap .ant-btn > .anticon-down {
  filter: none;
}
:root .ant-dropdown-wrap .ant-btn > .anticon-down {
  font-size: 12px;
}
.ant-dropdown-wrap .anticon-down:before {
  transition: transform 0.2s ease;
}
.ant-dropdown-wrap-open .anticon-down:before {
  transform: rotate(180deg);
}
.ant-dropdown-hidden,
.ant-dropdown-menu-hidden {
  display: none;
}
.ant-dropdown-menu {
  outline: none;
  position: relative;
  list-style-type: none;
  padding: 0;
  margin: 0;
  text-align: left;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);
  background-clip: padding-box;
}
.ant-dropdown-menu-item,
.ant-dropdown-menu-submenu-title {
  padding: 7px 8px;
  margin: 0;
  clear: both;
  font-size: 12px;
  font-weight: normal;
  color: rgba(0, 0, 0, 0.65);
  white-space: nowrap;
  cursor: pointer;
  transition: all .3s;
}
.ant-dropdown-menu-item > a,
.ant-dropdown-menu-submenu-title > a {
  color: rgba(0, 0, 0, 0.65);
  display: block;
  padding: 7px 8px;
  margin: -7px -8px;
  transition: all .3s;
}
.ant-dropdown-menu-item > a:focus,
.ant-dropdown-menu-submenu-title > a:focus {
  text-decoration: none;
}
.ant-dropdown-menu-item-selected,
.ant-dropdown-menu-submenu-title-selected,
.ant-dropdown-menu-item-selected > a,
.ant-dropdown-menu-submenu-title-selected > a {
  color: #108ee9;
  background-color: #ecf6fd;
}
.ant-dropdown-menu-item:hover,
.ant-dropdown-menu-submenu-title:hover {
  background-color: #ecf6fd;
}
.ant-dropdown-menu-item-disabled,
.ant-dropdown-menu-submenu-title-disabled {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}
.ant-dropdown-menu-item-disabled:hover,
.ant-dropdown-menu-submenu-title-disabled:hover {
  color: rgba(0, 0, 0, 0.25);
  background-color: #fff;
  cursor: not-allowed;
}
.ant-dropdown-menu-item:first-child,
.ant-dropdown-menu-submenu-title:first-child,
.ant-dropdown-menu-item:first-child > a,
.ant-dropdown-menu-submenu-title:first-child > a {
  border-radius: 4px 4px 0 0;
}
.ant-dropdown-menu-item:last-child,
.ant-dropdown-menu-submenu-title:last-child,
.ant-dropdown-menu-item:last-child > a,
.ant-dropdown-menu-submenu-title:last-child > a {
  border-radius: 0 0 4px 4px;
}
.ant-dropdown-menu-item:only-child,
.ant-dropdown-menu-submenu-title:only-child,
.ant-dropdown-menu-item:only-child > a,
.ant-dropdown-menu-submenu-title:only-child > a {
  border-radius: 4px;
}
.ant-dropdown-menu-item-divider,
.ant-dropdown-menu-submenu-title-divider {
  height: 1px;
  overflow: hidden;
  background-color: #e9e9e9;
  line-height: 0;
}
.ant-dropdown-menu-submenu-title:after {
  font-family: "anticon" !important;
  position: absolute;
  content: "\\e61f";
  right: 8px;
  color: rgba(0, 0, 0, 0.43);
  display: inline-block;
  font-size: 12px;
  font-size: 10px \9;
  transform: scale(0.83333333) rotate(0deg);
  /* IE6-IE8 */
  -ms-filter: "progid:DXImageTransform.Microsoft.Matrix(sizingMethod='auto expand', M11=1, M12=0, M21=0, M22=1)";
  zoom: 1;
}
:root .ant-dropdown-menu-submenu-title:after {
  filter: none;
}
:root .ant-dropdown-menu-submenu-title:after {
  font-size: 12px;
}
.ant-dropdown-menu-submenu-vertical {
  position: relative;
}
.ant-dropdown-menu-submenu-vertical > .ant-dropdown-menu {
  top: 0;
  left: 100%;
  position: absolute;
  min-width: 100%;
  margin-left: 4px;
  transform-origin: 0 0;
}
.ant-dropdown-menu-submenu.ant-dropdown-menu-submenu-disabled .ant-dropdown-menu-submenu-title,
.ant-dropdown-menu-submenu.ant-dropdown-menu-submenu-disabled .ant-dropdown-menu-submenu-title:after {
  color: rgba(0, 0, 0, 0.25);
}
.ant-dropdown-menu-submenu:first-child .ant-dropdown-menu-submenu-title {
  border-radius: 4px 4px 0 0;
}
.ant-dropdown-menu-submenu:last-child .ant-dropdown-menu-submenu-title {
  border-radius: 0 0 4px 4px;
}
.ant-dropdown.slide-down-enter.slide-down-enter-active.ant-dropdown-placement-bottomLeft,
.ant-dropdown.slide-down-appear.slide-down-appear-active.ant-dropdown-placement-bottomLeft,
.ant-dropdown.slide-down-enter.slide-down-enter-active.ant-dropdown-placement-bottomCenter,
.ant-dropdown.slide-down-appear.slide-down-appear-active.ant-dropdown-placement-bottomCenter,
.ant-dropdown.slide-down-enter.slide-down-enter-active.ant-dropdown-placement-bottomRight,
.ant-dropdown.slide-down-appear.slide-down-appear-active.ant-dropdown-placement-bottomRight {
  animation-name: antSlideUpIn;
}
.ant-dropdown.slide-up-enter.slide-up-enter-active.ant-dropdown-placement-topLeft,
.ant-dropdown.slide-up-appear.slide-up-appear-active.ant-dropdown-placement-topLeft,
.ant-dropdown.slide-up-enter.slide-up-enter-active.ant-dropdown-placement-topCenter,
.ant-dropdown.slide-up-appear.slide-up-appear-active.ant-dropdown-placement-topCenter,
.ant-dropdown.slide-up-enter.slide-up-enter-active.ant-dropdown-placement-topRight,
.ant-dropdown.slide-up-appear.slide-up-appear-active.ant-dropdown-placement-topRight {
  animation-name: antSlideDownIn;
}
.ant-dropdown.slide-down-leave.slide-down-leave-active.ant-dropdown-placement-bottomLeft,
.ant-dropdown.slide-down-leave.slide-down-leave-active.ant-dropdown-placement-bottomCenter,
.ant-dropdown.slide-down-leave.slide-down-leave-active.ant-dropdown-placement-bottomRight {
  animation-name: antSlideUpOut;
}
.ant-dropdown.slide-up-leave.slide-up-leave-active.ant-dropdown-placement-topLeft,
.ant-dropdown.slide-up-leave.slide-up-leave-active.ant-dropdown-placement-topCenter,
.ant-dropdown.slide-up-leave.slide-up-leave-active.ant-dropdown-placement-topRight {
  animation-name: antSlideDownOut;
}
.ant-dropdown-trigger .anticon-down,
.ant-dropdown-link .anticon-down {
  display: inline-block;
  font-size: 12px;
  font-size: 10px \9;
  transform: scale(0.83333333) rotate(0deg);
  /* IE6-IE8 */
  -ms-filter: "progid:DXImageTransform.Microsoft.Matrix(sizingMethod='auto expand', M11=1, M12=0, M21=0, M22=1)";
  zoom: 1;
}
:root .ant-dropdown-trigger .anticon-down,
:root .ant-dropdown-link .anticon-down {
  filter: none;
}
:root .ant-dropdown-trigger .anticon-down,
:root .ant-dropdown-link .anticon-down {
  font-size: 12px;
}
.ant-dropdown-button {
  white-space: nowrap;
}
.ant-dropdown-button.ant-btn-group > .ant-btn:last-child:not(:first-child) {
  padding-right: 8px;
}
.ant-dropdown-button .anticon-down {
  display: inline-block;
  font-size: 12px;
  font-size: 10px \9;
  transform: scale(0.83333333) rotate(0deg);
  /* IE6-IE8 */
  -ms-filter: "progid:DXImageTransform.Microsoft.Matrix(sizingMethod='auto expand', M11=1, M12=0, M21=0, M22=1)";
  zoom: 1;
}
:root .ant-dropdown-button .anticon-down {
  filter: none;
}
:root .ant-dropdown-button .anticon-down {
  font-size: 12px;
}
.ant-dropdown-menu-dark,
.ant-dropdown-menu-dark .ant-dropdown-menu {
  background: #404040;
}
.ant-dropdown-menu-dark .ant-dropdown-menu-item,
.ant-dropdown-menu-dark .ant-dropdown-menu-submenu-title,
.ant-dropdown-menu-dark .ant-dropdown-menu-item > a {
  color: rgba(255, 255, 255, 0.67);
}
.ant-dropdown-menu-dark .ant-dropdown-menu-item:after,
.ant-dropdown-menu-dark .ant-dropdown-menu-submenu-title:after,
.ant-dropdown-menu-dark .ant-dropdown-menu-item > a:after {
  color: rgba(255, 255, 255, 0.67);
}
.ant-dropdown-menu-dark .ant-dropdown-menu-item:hover,
.ant-dropdown-menu-dark .ant-dropdown-menu-submenu-title:hover,
.ant-dropdown-menu-dark .ant-dropdown-menu-item > a:hover {
  color: #fff;
  background: transparent;
}
.ant-dropdown-menu-dark .ant-dropdown-menu-item-selected,
.ant-dropdown-menu-dark .ant-dropdown-menu-item-selected:hover,
.ant-dropdown-menu-dark .ant-dropdown-menu-item-selected > a {
  background: #108ee9;
  color: #fff;
}
.ant-dropdown-menu-container {
  overflow: hidden;
  width: 150px;
}
.ant-dropdown-link {
  color: #108ee9;
  background: transparent;
  text-decoration: none;
  outline: none;
  cursor: pointer;
  transition: color .3s ease;
}
.ant-dropdown-link i {
  margin-left: 5px;
  box-sizing: border-box;
  width: 20px;
  height: 20px;
}
.ant-dropdown-input {
  display: inline-block;
  height: 20px;
  width: 70px;
  border: none;
  background: transparent;
}
.ant-dropdown-operate {
  display: inline-block;
  position: absolute;
  top: 1px;
  right: 4px;
  background: transparent;
  padding: 7px 2px;
}
.ant-dropdown-menu-item {
  position: relative;
  width: 150px;
}
.mousedown {
  color: blue;
}
.antfocusline {
  border: 1px solid  #108ee9;
}
.color-change {
  color: #108ee9;
}
`]
})
export class DropDownComponent implements OnInit, OnChanges {
  public _isToggle = false;
  public _isMouseDown = false;
  messages: any = [];
  title = 'toggle';
  addText: string;
  _flagTouch_del = false;
  _flagTouch_add = false;
  _flagTouch_reserve = false;
  _flagTouch_default = false;
  @Input() options;
  @Input() searchMessage: Object[];
  @Output() uploadMessage: EventEmitter<any> = new EventEmitter();
  @Output() addMessage: EventEmitter<any> = new EventEmitter();
  @Output() delMessage: EventEmitter<any> = new EventEmitter();
  @Output() defaultMessage: EventEmitter<any> = new EventEmitter();
  constructor(
    public renderer: Renderer2,
    public _http: Http,
    public _ob: DropDownService
  ) {
  }
  ngOnInit() {
    // this.options.searchMessage(this._http, this._ob);
    // this._ob.subject$.subscribe((data: Array<any>) => {
    //   // this.messages = data;
    // })
  }
  ngOnChanges(options: SimpleChanges) {
    let changeValue = options.searchMessage;
    if (!changeValue.firstChange) {
      this.messages = changeValue.currentValue.map(item => {
        item._isFlag = true;
        item._isFocusLine = false;
        return item;
      })
    }
  }
  editItem(event, index) {
    this.messages[index]['_isFlag'] = false;
    this.messages[index]['_isFocusLine'] = true;
  }
  delItem(event, index) {
    this._flagTouch_del = true;
    this.delMessage.emit(this.messages[index]);
    let return_cb = this._ob.subject$.subscribe((data) => {
      if (data) {
        this.messages.splice(index, 1);
        return_cb.unsubscribe();
        alert('删除成功');
        return;
      }
      return_cb.unsubscribe();
      alert('删除失败');
    })
  }
  reserveItem(event, index) {
    this._flagTouch_reserve = true;
    this.uploadMessage.emit(this.messages[index]);
    let return_cb = this._ob.subject$.subscribe((data) => {
      // if (data[0]['result']) {
      if (data) {
        this.messages[index]['_isFlag'] = true;
        this.messages[index]['_isFocusLine'] = false;
        return_cb.unsubscribe();
        alert('修改成功');
        return;
      }
      return_cb.unsubscribe();
      alert('修改失败');
    });
  }
  addItem() {
    this._flagTouch_add = true;
    if (!this.addText) {
      alert('不能为空');
      return;
    }
    this.addMessage.emit(this.addText);
    let return_cb = this._ob.subject$.subscribe((data: any[]) => {
      // if (data[0]['result']) {
        console.log(data)
        if (data) {
          // id: data[0]['data']['id'],
        this.messages.unshift({ id: data.length + 1, title: this.addText, _isFlag: true, _isFocusLine: false });
        return_cb.unsubscribe();
        this.addText = '';
      } else {
        return_cb.unsubscribe();
        alert(data[0]['message']);
      }
    })
  }
  defaultItem(event, index) {
    this._flagTouch_default = true;
    this.defaultMessage.emit(this.messages[index])
    let return_cb = this._ob.subject$.subscribe((data: any[]) => {
      // if (data[0]['result']) {
        if (data) {
        let res = data[0].data;
        // if (data['isDefault']) {
        if (data) {
          this.messages[index].isDefault = false;
        } else {
          this.messages[index].isDefault = true;
        }
        return_cb.unsubscribe();
        return;
      }
      alert(data[0]['message']);
      return_cb.unsubscribe();
    })
  }
}
